import { createSlice } from "@reduxjs/toolkit";

export interface ClientCardsState {
  cardMask: string;
  cardGuid: string;
}

const initialState: ClientCardsState[] = [];

export const clientCardsSlice = createSlice({
  name: "clientCards",
  initialState,
  reducers: {
    setClientCards: (state, { payload }) => {
      return payload;
    },
  },
});

export const { setClientCards } = clientCardsSlice.actions;
export default clientCardsSlice.reducer;
